import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "support"
    }}>{`Support`}</h1>
    <p>{`Please create a support ticket on `}<inlineCode parentName="p">{`Ticksy`}</inlineCode>{` if you faced any issues.`}</p>
    <p><a parentName="p" {...{
        "href": "https://redqsupport.ticksy.com/"
      }}>{`https://redqsupport.ticksy.com/`}</a></p>
    <blockquote>
      <p parentName="blockquote">{`But before open a ticket, we suggest you to check `}<a parentName="p" {...{
          "href": "/faq"
        }}>{`FAQ`}</a>{` and `}<a parentName="p" {...{
          "href": "/customization"
        }}>{`Customization`}</a>{` section. There is a high chance we already provide a solution on that `}<inlineCode parentName="p">{`faq`}</inlineCode>{` or `}<inlineCode parentName="p">{`customization`}</inlineCode>{` section.`}</p>
    </blockquote>
    <p>{`Also, We strictly follow the Envato item support policy `}<a parentName="p" {...{
        "href": "https://themeforest.net/page/item_support_policy"
      }}>{`https://themeforest.net/page/item_support_policy`}</a>{`
you can find what's not included in the support there`}</p>
    <p><img alt="Support.png" src={require("./images/Support.png")} /></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      